const permissionName = {
  CREATE: { name: 'Add', codePart: 'add' },
  READ: { name: 'Read', codePart: 'view' },
  UPDATE: { name: 'Edit', codePart: 'change' },
  DELETE: { name: 'Delete', codePart: 'delete' },
}

export default permissionName